import ArchiveButton from './component';

export default ArchiveButton;
